import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'latest-nvtuan-2026': 'https://readdy.ai/api/search-image?query=A%20blurred%20couple%20silhouette%20walking%20in%20a%20dark%20alley%20at%20night%2C%20paparazzi%20style%20photography%2C%20grainy%20film%20texture%2C%20mysterious%20atmosphere%2C%20warm%20street%20lamp%20light%2C%20voyeuristic%20perspective%2C%20editorial%20quality&width=800&height=440&seq=latest-nvtuan-2026&orientation=landscape',
  'latest-kaoyan-2026': 'https://readdy.ai/api/search-image?query=A%20fake%20diploma%20burning%20with%20flames%20on%20a%20dark%20surface%2C%20dramatic%20fire%20lighting%2C%20symbolic%20of%20exposed%20lies%2C%20dark%20background%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20photography&width=800&height=440&seq=latest-kaoyan-2026&orientation=landscape',
  'latest-huadan-2026': 'https://readdy.ai/api/search-image?query=Two%20spotlights%20crossing%20and%20clashing%20in%20a%20dark%20theater%20space%2C%20dramatic%20confrontation%20metaphor%2C%20intense%20warm%20and%20cool%20lighting%20contrast%2C%20cinematic%20atmosphere%2C%20abstract%20composition%2C%20editorial%20photography&width=800&height=440&seq=latest-huadan-2026&orientation=landscape',
  'latest-xuanxiu-2026': 'https://readdy.ai/api/search-image?query=A%20tampered%20voting%20ballot%20box%20in%20dramatic%20lighting%2C%20shadowy%20hands%20manipulating%20papers%2C%20dark%20corrupt%20atmosphere%2C%20film%20noir%20style%2C%20high%20contrast%20black%20and%20red%20tones%2C%20editorial%20photography&width=800&height=440&seq=latest-xuanxiu-2026&orientation=landscape',
  'latest-taoshui-2026': 'https://readdy.ai/api/search-image?query=An%20empty%20luxurious%20livestreaming%20room%20with%20dim%20lights%2C%20abandoned%20products%20on%20desk%2C%20cerie%20silence%20atmosphere%2C%20dark%20and%20cold%20mood%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=440&seq=latest-taoshui-2026&orientation=landscape',
  'latest-hunwai-2026': 'https://readdy.ai/api/search-image?query=A%20wedding%20ring%20shattered%20on%20a%20dark%20marble%20surface%2C%20dramatic%20lighting%2C%20symbolic%20of%20broken%20marriage%2C%20dark%20melancholic%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography&width=800&height=440&seq=latest-hunwai-2026&orientation=landscape',
};

export default function LatestSection() {
  return (
    <section id="latest" className="bg-background-100 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">实时追踪</p>
            <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950">
              最新<span className="text-primary-500">黑料</span>
            </h2>
          </div>
          <Link
            to="/category/jin-ri-da-gua"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.slice(0, 6).map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/jin-ri-da-gua"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}